exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".hidden-border{border:0!important;background:#fff!important}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/components/subcate_view.vue"],"names":[],"mappings":"AACA,eACE,mBAAsB,AACtB,yBAA2B,CAC5B","file":"subcate_view.vue","sourcesContent":["\n.hidden-border {\n  border: 0px!important;\n  background: #fff!important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59d11e5a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/subcate_view.vue
// module id = 253
// module chunks = 0 3